<!-- 物流详情 -->
<template>
  <div>
    <van-popup
      v-model="show"
      position="bottom"
      :style="{ height: '70%' }"
      duration="0.17"
      @click-overlay="close"
    >
      <div class="section">
        <h1 class="title">
          <p>物流详情</p>
          <van-icon @click="close" name="cross" />
        </h1>
        <div class="section-box" v-if="logistics">
          <div class="logistics">
            <div class="logistics-box">
              <span>{{ logistics.expName }}</span
              ><b>{{ logistics.number }}</b
              ><img @click="orderNoCopy" src="@/assets/img/personalCenter/copy.png" alt="" />
            </div>
            <button>{{ deliveryStatus[Number(logistics.deliveryStatus)] }}</button>
          </div>
          <ul class="deliver">
            <li v-for="(item, index) in logistics.list" :key="index">
              <img v-if="index === 0" src="../../../../assets/img/personalImg/checked.png" alt="" />
              <img v-else src="../../../../assets/img/personalImg/check.png" alt="" />
              <p>{{ item.status }}</p>
              <b>{{ item.time.slice(5) }}</b>
            </li>
          </ul>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { reqExpressDelivery } from '@/api/personal/logistics/index';
import { copyTool } from '@/utils/tools';

export default {
  data() {
    return {
      show: false,
      logistics: null,
      deliveryStatus: {
        0: '揽件中',
        1: '在途中',
        2: '派件中',
        3: '已签收',
        4: '派送失败',
        5: '疑难件',
        6: '退件签收',
      },
    };
  },
  props: {
    showDetail: {
      type: Boolean,
      default: false,
    },
    deliverData: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    showDetail(data) {
      this.show = data;
      if (data) {
        const { phone, expressNo } = this.deliverData;
        this.getDetail(phone, expressNo);
      }
    },
  },
  components: {},

  computed: {},

  mounted() {},

  created() {},

  methods: {
    orderNoCopy() {
      copyTool(this.logistics.number)
        .then(() => {
          this.$toast('复制单号成功');
        })
        .catch(() => {
          this.$toast('复制失败');
        });
    },
    close() {
      this.$emit('close', 0);
    },
    async getDetail(addresseePhone, expressNo) {
      const { code, data } = await reqExpressDelivery(addresseePhone, expressNo);
      if (code === 0 && data) {
        this.logistics = data;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.section {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  .title {
    position: relative;
    width: 100%;
    padding: 40px 0 10px 0;
    p {
      color: #333;
      font-weight: 800;
      font-size: 36px;
      text-align: center;
    }
    ::v-deep .van-icon-cross {
      position: absolute;
      top: 18px;
      right: 18px;
      font-size: 20px;
    }
  }
  .section-box {
    flex: 1;
    width: 100%;
    overflow: auto;
  }
  .logistics {
    display: flex;
    align-content: center;
    justify-content: space-between;
    width: 670px;
    height: 112px;
    margin: 60px auto;
    padding: 36px;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    .logistics-box {
      display: flex;
      align-content: center;
      justify-content: flex-start;
      span {
        color: #333;
        font-weight: 800;
        font-size: 28px;
        line-height: 40px;
      }
      b {
        display: inline-block;
        width: 250px;
        padding: 0 6px;
        overflow: hidden;
        color: #787878;
        font-weight: 400;
        font-size: 28px;
        line-height: 40px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      img {
        width: 36px;
        height: 36px;
      }
    }
    button {
      height: 36px;
      padding: 2px 10px;
      color: #fff;
      font-weight: 400;
      font-size: 24px;
      line-height: 34px;
      background: #ff6c02;
      border-radius: 8px;
    }
  }
  .deliver {
    padding: 0 40px;
    li {
      position: relative;
      padding: 0 0 40px 44px;
      border-left: 1px solid #d8d8d8;
      img {
        position: absolute;
        top: -5px;
        left: -15px;
        width: 32px;
        height: 32px;
      }
      p {
        color: #a5a5a5;
        font-weight: 400;
        font-size: 24px;
        line-height: 34px;
      }
      b {
        color: #a5a5a5;
        font-weight: 400;
        font-size: 24px;
      }
    }
    li:last-child {
      border: none;
    }
  }
}
</style>
